import {
  FAQS,
  AnalyticsHeader,
  REGISTRATION_CARDS,
  TERMS_AND_CONDITION,
  REGISTER_TERMS_AND_CONDITION,
} from "./helper";
import { routes } from "src/shared/routes";
import { constants } from "src/shared/constants";

import type { TTeamConfig } from "src/shared/types/teamConfig.types";

const logo =
  "https://ss-leagues.s3.amazonaws.com/MLS/Sounders/seattle-sounders-logo.png";
const landingPageStaticBannerUrl =
  "https://ss-leagues.s3.amazonaws.com/MLS/Sounders/26_FMOU_Banner_Web_1920x450.png";
const mobileLandingPageStaticBannerUrl =
  "https://ss-leagues.s3.amazonaws.com/MLS/Sounders/26_FMOU_Banner_Mobile_375x550.png";

export const seattlesounders_pass: TTeamConfig = {
  TEAM_SCHEMA: "seattlesounders_pass",
  TEAM_FULL_NAME: "Seattle Sounders FC",
  BROWSER_TITLE: "Sounders First Match on Us",
  CLIENT_ID: "c244269e0844.seasonshare.sixers-sixers.us",
  VENDOR: constants.vendorUUIDs.ticketmaster,

  TEAM_GLOBAL_SETTINGS: {
    COLORS_PRIMARY: "#000000",
    COLORS_SECONDARY: "#0000FF",
    LOGOUT_ON_INVALID_SESSION: false,
    DEFAULT_APP_ROUTE: routes.landing,
    ANALYTICS_HEADER: AnalyticsHeader,
    NAV_MENU: {
      HIDE_EARN_REWARDS: true,
      HIDE_MANAGE_SUBSCRIPTION: true,
    },

    FOOTER: {
      BACKGROUND_COLOR: "#0000FF",
    },
  },

  LANDING_PAGE_SETTINGS: {
    HIDE_PASSES: true,

    PASS_BANNER: {
      PASS_DISPLAY_MODE: "separate",
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },

    PASS: {
      HIDE_DECIMAL_POINTS_AFTER_PRICE: true,
      SUBSCRIBE_BUTTON_TEXT: "Purchase Now",
      SHOW_FAQ_BUTTON: true,
    },

    SHOW_ALL_EVENTS_UNDER_PASS: true,

    STATIC_BANNER: {
      IS_ENABLED: true,
      IS_FLUID_BACKGROUND_IMAGE_SIZE: true,
    },

    REGISTRATION_CARD_SETTINGS: {
      REGISTRATION_CARDS,
      SECTION_TITLE:
        "Experience the energy, passion, and atmosphere of a live match.",
    },
  },

  AUTH_PAGE_SETTINGS: {
    PHONE_INPUT_WIDGET: {
      TERMS_AND_CONDITION: <REGISTER_TERMS_AND_CONDITION />,
      PHONE_INPUT_DESCRIPTION:
        "Receive ticketing and matchday related updates only.",
    },
  },

  HOME_PAGE_SETTINGS: {
    ATTEND_EVENT_MODAL: {
      TITLE: "Manage Ticket Reservation",
      DESCRIPTION: (
        <>
          You have secured your free ticket reservation. If you are unable to
          attend, you must cancel at least 48 hours in advance.
        </>
      ),
      ATTEND_BUTTON_LABEL: "Secure Your Seats",
      NOT_ATTENDING_BUTTON_LABEL: "Cancel Reservation",
      ATTEND_BUTTON_ATTENDING_LABEL: "Reserved",
      ATTEND_BUTTON_NOT_ATTENDING_LABEL: "Not Reserved",

      ATTENDANCE_SUCCESS_TOAST: {
        OPT_IN_SUCCESS_MESSAGE:
          "Your reservation has been updated successfully.",
        OPT_OUT_SUCCESS_MESSAGE:
          "Your reservation has been cancelled successfully.",
      },

      SEAT_COUNT_SELECTOR_TITLE: "Claim Your Free Seats",
      SECONDARY_CONFIRMATION_DESCRIPTION:
        "You're one click away from your first Sounders FC match! Please confirm your attendance before the deadline",
      SECONDARY_CANCEL_BUTTON_LABEL: "Release Reservation (Unable to Attend)",
    },

    EVENT_CARD: {
      SHOW_SINGLE_GAMES_IN_COLLAPSE: true,
      ATTEND_BUTTON_LABEL: "Claim Free Tickets",
      IS_RESERVATION_ENABLED: true,
      RESERVATION_LIMIT_REACHED_MESSAGE:
        "You have already reserved your complimentary game.",

      ATTEND_BUTTON_COLOR: "#00FF61",
      ATTEND_BUTTON_TEXT_COLOR: "#000000",

      RESERVATION_ADD_ON_SEATS_CLAIMED_MESSAGE:
        "This reservation cannot be canceled because additional guest tickets have been purchased for the event.",

      RESERVATION_OPT_OUT_DISABLED_MESSAGE: (
        <>
          The window to cancel your reservation has closed. Please call{" "}
          <a href="tel:8776574625">(877) 657-4625</a> for additional help.
        </>
      ),

      SEAT_COUNT_LIMIT_REACHED_MESSAGE:
        "All seats for this event have been reserved. Please check back in case additional seats become available.",

      USE_OPTED_IN_COUNT_FOR_EVENT_RESERVATION: true,
      CONFIRM_ATTENDANCE_BUTTON_BACKGROUND_COLOR: "#0000FF",
    },

    ADD_ON: {
      OPT_IN_REQUIRED_MESSAGE:
        "Please complete your event reservation before purchasing additional guest tickets.",

      ADD_ON_BUTTON_LABEL: "Add On Tickets",
    },

    PAGE_TITLE: "First Match On Us Schedule",
    ALL_GAMES_BUTTON_LABEL: "Upcoming Matches",
  },

  GROUP_INVITE_PAGE_SETTINGS: {
    PASS_BANNER: {
      DISABLE_BACKGROUND_IMAGE_FILTER: true,
      PASS_DISPLAY_MODE: "separate",
    },
  },

  CHECKOUT_PAGE_SETTINGS: {
    CHECKOUT_FORM: {
      SAVE_CARD_SWITCH_ENABLED: false,
    },

    ADD_DARK_OVERLAY: true,
  },

  MANAGE_SUBSCRIPTION_PAGE_SETTINGS: {
    ZERO_STATE: {
      OPT_OUT_EARLIEST_DATE: new Date("10/01/2024"),
    },
  },

  IMAGES: {
    LOGO_URL: logo,
    ORDER_SUMMERY_BACKGROUND_URL: landingPageStaticBannerUrl,
    LANDING_PAGE_STATIC_BANNER_URL: landingPageStaticBannerUrl,
    MOBILE_LANDING_PAGE_STATIC_BANNER_URL: mobileLandingPageStaticBannerUrl,
  },

  LANGUAGES: {
    FAQS,
    TERMS_AND_CONDITION,
  },
};
